import { useQuery } from 'react-query';
import PlaylistsApi, { PlaylistContentType } from './api';

export function usePlaylistStatus(
  contentId: string | undefined,
  contentType: PlaylistContentType | undefined,
  enabled = true,
) {
  return useQuery(
    ['playlist-status', contentId, contentType],
    () => PlaylistsApi.getStatus(contentId!, contentType!),
    {
      enabled: !!contentId && !!contentType && enabled,
      staleTime: 20_000,
      retry: false,
    },
  );
}
